export default (prefix, routes) => {
  routes.forEach(route => {
    route.path = prefix + route.path
  })
  return routes
}
